import Vue from 'vue'

import {en} from "../../assets/localization/language_en.js"
import {ru} from "../../assets/localization/language_ru.js"
import {ua} from "../../assets/localization/language_ua.js"

const has_custom_localize = {
    en: document.body.classList.contains('has-custom-localize-en'),
    ru: document.body.classList.contains('has-custom-localize-ru'),
    ua: document.body.classList.contains('has-custom-localize-ua')
};

export default async (data) => {
    if (process.env.NODE_ENV === "development") {
        return new Promise(resolve => {
            const list = {
                en,
                ru,
                ua
            };
            resolve(list[data.code])
        })
    } else {
        const localize = await Vue.Api.Get(data.API_ORIGIN + data.PATH + `/Content/localization/language_${data.code}.js`);

        let customLocalize = null;
        if (has_custom_localize[data.code]) {
            customLocalize = await Vue.Api.Get(data.API_ORIGIN + data.PATH + `/Content/localization/language_${data.code}_custom.js`);
        }

        return localize.data + (customLocalize ? customLocalize.data : "")
    }
}
